module.exports = __webpack_public_path__ + "img/not-found-2.877a90cc.png";